import { supabase } from '../lib/supabase';

const TABLE_NAME = 'client_site_addresses';

// Get all site addresses for a client
export const getClientSiteAddresses = async (clientId) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('client_id', clientId)
    .order('is_primary', { ascending: false })
    .order('created_at', { ascending: true });

  if (error) throw error;
  return data || [];
};

// Get primary site address for a client
export const getPrimarySiteAddress = async (clientId) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('client_id', clientId)
    .eq('is_primary', true)
    .single();

  if (error && error.code !== 'PGRST116') throw error; // PGRST116 is "not found"
  return data || null;
};

// Create a new site address
export const createSiteAddress = async (addressData) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .insert([addressData])
    .select()
    .single();

  if (error) throw error;
  
  // If this address is set as primary, unset others
  if (addressData.is_primary) {
    await unsetOtherPrimaryAddresses(addressData.client_id, data.id);
  }
  
  return data;
};

// Update a site address
export const updateSiteAddress = async (addressId, updates) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .update(updates)
    .eq('id', addressId)
    .select()
    .single();

  if (error) throw error;
  
  // If this address is set as primary, unset others
  if (updates.is_primary) {
    await unsetOtherPrimaryAddresses(data.client_id, addressId);
  }
  
  return data;
};

// Delete a site address
export const deleteSiteAddress = async (addressId) => {
  const { error } = await supabase
    .from(TABLE_NAME)
    .delete()
    .eq('id', addressId);

  if (error) throw error;
};

// Helper function to unset other primary addresses
const unsetOtherPrimaryAddresses = async (clientId, excludeAddressId) => {
  const { error } = await supabase
    .from(TABLE_NAME)
    .update({ is_primary: false })
    .eq('client_id', clientId)
    .eq('is_primary', true)
    .neq('id', excludeAddressId);

  if (error) throw error;
};
